<template>
  <header class="header">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="header_container d-flex flex-row align-items-center justify-content-start">
            <!-- Logo -->
            <div class="logo_container">
              <div class="logo">
                <!-- <div>Marena</div> -->
                <!-- <div>biuro podróży</div> -->
                <div class="logo_image"><img src="/images/logo_big.png" /></div>
              </div>
            </div>

            <!-- Main Navigation -->
            <nav class="main_nav ml-auto">
              <ul class="main_nav_list">
                <li class="main_nav_item">
                  <router-link to="/">Aktualności</router-link>
                </li>
                <li class="main_nav_item">
                  <router-link to="/o_nas">O nas</router-link>
                </li>
                <li class="main_nav_item">
                  <router-link to="/oferty">Oferty</router-link>
                </li>
                <li class="main_nav_item">
                  <router-link to="/kontakt">Kontakt</router-link>
                </li>
              </ul>
            </nav>

            <!-- Search -->
            <div class="search" :class="{ active: searchActive }">
              <input
                v-model="searchPhrase"
                type="search"
                name="search_input"
                class="search_input ctrl_class"
                required="required"
                placeholder="Keyword"
                @keydown.enter="performSearch"
              />
              <button class="search_button ml-auto" @click="searchActive = !searchActive">
                <img src="/images/search.png" alt="" />
              </button>
            </div>

            <!-- Hamburger -->
            <div class="hamburger ml-auto"><i class="fa fa-bars" aria-hidden="true"></i></div>
          </div>
        </div>
      </div>
    </div>

    <div class="menu_container menu_mm">
      <!-- Menu Close Button -->
      <div class="menu_close_container">
        <div class="menu_close"></div>
      </div>

      <!-- Menu Items -->
      <div class="menu_inner menu_mm">
        <div class="menu menu_mm">
          <div class="menu_search_form_container">
            <form id="menu_search_form" action="#">
              <input type="search" class="menu_search_input menu_mm" />
              <button id="menu_search_submit" class="menu_search_submit" type="submit">
                <img src="images/search_2.png" alt="" />
              </button>
            </form>
          </div>
          <ul class="menu_list menu_mm">
            <li class="menu_item menu_mm">
              <router-link to="/">Aktualności</router-link>
            </li>
            <li class="menu_item menu_mm">
              <router-link to="/o_nas">O nas</router-link>
            </li>
            <li class="menu_item menu_mm">
              <router-link to="/oferty">Oferty</router-link>
            </li>
            <li class="menu_item menu_mm">
              <router-link to="/kontakt">Kontakt</router-link>
            </li>
          </ul>

          <!-- Menu Social -->

          <div class="menu_social_container menu_mm">
            <ul class="menu_social menu_mm">
              <li class="menu_social_item menu_mm">
                <a href="https://www.instagram.com/marena.gorlice/"
                  ><i class="fa fa-instagram" aria-hidden="true"></i
                ></a>
              </li>
              <li class="menu_social_item menu_mm">
                <a href="https://web.facebook.com/biuropodrozy.marena/"
                  ><i class="fa fa-facebook" aria-hidden="true"></i
                ></a>
              </li>
              <li class="menu_social_item menu_mm">
                <a href="https://www.youtube.com/channel/UCOzP6-lTg6Zs4tHJqibFzDw"
                  ><i class="fa fa-youtube" aria-hidden="true"></i
                ></a>
              </li>
            </ul>
          </div>

          <div class="menu_copyright menu_mm">Colorlib All rights reserved</div>
        </div>
      </div>
    </div>
  </header>

  <!-- Menu -->
</template>

<script>
export default {
  name: 'Menu',
  data() {
    return {
      searchActive: false,
      searchPhrase: '',
    }
  },
  methods: {
    performSearch() {
      this.$router.push({ name: 'oferty', query: { search: this.searchPhrase } })
    },
  },
}
</script>

<style scoped>
/* .router-link-exact-active::after {
  background: #ef7e1a;
} */
.router-link-exact-active {
  color: #ef7e1a;
  background: #222738;
}
.main_nav_item {
  padding-top: 0;
}
.main_nav_item:hover a {
  color: #ef7e1a;
}
.search {
  background: #ef7e1a;
  cursor: initial;
}
.search:hover {
  background: #ef7e1a;
}
.search_button {
  cursor: pointer;
  pointer-events: initial;
}
.hamburger:hover i {
  color: #ef7e1a;
}
.menu_item a:hover {
  color: #ef7e1a;
}
.menu_close_container:hover .menu_close::after {
  background: #ef7e1a;
}
.menu_social_item a i:hover {
  color: #ef7e1a;
}
.find_button {
  background: #ef7e1a !important;
}

.logo_image {
  width: 150px;
  height: 150px;
  top: 24px;
  margin: auto;
  position: relative;
  left: -30px;
}
.header.scrolled .logo_image {
  width: 100px;
  height: 100px;
  top: 14px;
  left: -35px;
}
@media screen and (max-width: 576px) {
  .logo_image {
    width: 80px !important;
    height: 80px !important;
    top: 10px !important;
    left: -15px !important;
  }
}
</style>
